import { useEffect } from 'react';
import useConfig from './useConfig';

/**
 * Syncs FlyonUI/Tailwind dark mode with theme mode
 * Sets data-theme attribute on the <html> element based on theme mode
 * Must be used at app root level (e.g., in App.tsx)
 */
const useTailwindDarkMode = () => {
  const { mode } = useConfig();

  useEffect(() => {
    const root = document.documentElement;

    const setTheme = (theme: 'dark' | 'light') => {
      root.setAttribute('data-theme', theme);
    };

    if (mode === 'dark') {
      setTheme('dark');
    } else if (mode === 'light') {
      setTheme('light');
    } else if (mode === 'auto') {
      // Check system preference for auto mode
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      setTheme(prefersDark ? 'dark' : 'light');

      // Listen for system preference changes
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const handleChange = (e: MediaQueryListEvent) => {
        setTheme(e.matches ? 'dark' : 'light');
      };

      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }
  }, [mode]);
};

export default useTailwindDarkMode;
